module.exports = __webpack_public_path__ + "entry-41b28522/isabel-photo-923eeae8ecca678549bbde77eacfae09.webp";